import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from '../../../../configuration/setup/hooks';
import { getSelectedCategory } from '../../reducers/transportAssignmentsSlice';
import { getTableViewType } from '../../reducers/viewSlice';
import { ContentLoadingRow } from '../../sharedComponents/table/BaseTableComponents';
import { getTableClassNames } from '../../sharedComponents/table/SortedTableHeader';
import { useSelectedTableColumns } from '../../sharedComponents/table/useSelectedTableColumns';
import { useGetUserTriggeredFetching } from '../../sharedComponents/userTriggeredFetchingHook';
import { TransportAssignment } from '../transportAssignment.types';
import { TableCategory } from '../tableCategory.types';
import { TransportAssignmentRow } from './TransportAssignmentsTableRow';
import { TransportAssignmentTableColumn } from './TransportAssignmentTableColumns';
import { TransportAssignmentTableHeader } from './TransportAssignmentTableHeader';
import classNames from 'classnames';
import { TransportAssignmentSelectionCell } from './TransportAssignmentSelectionCell';
import { TransportAssignmentBulkSelectionDropdown } from './TransportAssignmentBulkSelectionDropdown';

type TransportAssignmentTableProps = {
    readonly transportAssignments: readonly TransportAssignment[];
};

export const TransportAssignmentsTable = ({ transportAssignments }: TransportAssignmentTableProps) => {
    const activeTableCategory = useAppSelector(getSelectedCategory);
    const isFetchingQueryTriggerByUser = useGetUserTriggeredFetching();
    const viewType = useAppSelector(getTableViewType);

    const tableClassNames = getTableClassNames(transportAssignments, viewType);

    const isArchiveTab = activeTableCategory === TableCategory.ARCHIVE;
    const columnDefinition = useSelectedTableColumns<TransportAssignmentTableColumn>();

    const numberOfSpecialColumns = 1;
    const numberOfColumns = numberOfSpecialColumns + columnDefinition.length;

    return (
        <table className={tableClassNames}>
            <colgroup>
                <col className="width-50" />
                {columnDefinition.map((def) => (
                    <col key={def.column} className={classNames(def.fixedWith && `width-${def.fixedWith}`)} />
                ))}
            </colgroup>
            <TransportAssignmentTableHeader
                columnDefinition={columnDefinition}
                selectionHeader={<TransportAssignmentBulkSelectionDropdown />}
            />
            <tbody>
                {isFetchingQueryTriggerByUser ? (
                    <ContentLoadingRow numberOfColumns={numberOfColumns} />
                ) : transportAssignments.length <= 0 ? (
                    <tr>
                        <td colSpan={numberOfColumns}>
                            <NotFoundState
                                headline={<FormattedMessage id="outboundPortal.transportAssignments.notFound" />}
                                outerClassName="border-none"
                            />
                        </td>
                    </tr>
                ) : (
                    transportAssignments.map((transportAssignment: TransportAssignment) => (
                        <TransportAssignmentRow
                            key={transportAssignment.id}
                            transportAssignment={transportAssignment}
                            isArchivedTab={isArchiveTab}
                            columnDefinition={columnDefinition}
                            selectionCell={<TransportAssignmentSelectionCell assignmentId={transportAssignment.id} />}
                        />
                    ))
                )}
            </tbody>
        </table>
    );
};
